import React from "react";

const CivilMaterials = ({
  image,
  quotationType,
  a_FramePercent,
  flatBedPercent,
  growBagPercent,
  dutchBucketPercent,
}) => {
  let serial = 1;
  return (
    <div style={{ pageBreakInside: "avoid" }}>
      <h3 style={{ marginTop: "40px" }}>Civil Materials</h3>
      <p className="fs-3 mb-0">Specifications :</p>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "30%" }}>Item</th>
            <th>Description / Specification</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{serial++}</td>
            <td>Levelling of the land</td>
            <td>
              {" "}
              {quotationType !== "fanpad" &&
              quotationType !== "nvph" &&
              quotationType !== "nethouse" &&
              quotationType !== "soilbasedfanpad" &&
              quotationType !== "soilbasednethouse" &&
              quotationType !== "soilbasednvph"
                ? "Area should be leveled for laying of hydroponic piping, pathway area inside polyhouse."
                : "Area should be leveled."}
            </td>
          </tr>
          {quotationType !== "fanpad" &&
            quotationType !== "nvph" &&
            quotationType !== "nethouse" &&
            quotationType !== "soilbasedfanpad" &&
            quotationType !== "soilbasednvph" &&
            quotationType !== "soilbasednethouse" &&
            (a_FramePercent > 0 || flatBedPercent > 0) && (
              <>
                {a_FramePercent > 0 && (
                  <tr>
                    <td>{serial++}</td>
                    <td>Foundation for frames</td>
                    <td>
                      Civil material required for A shape frames foundation.
                      (Cement and sand)
                    </td>
                  </tr>
                )}
                <tr>
                  <td>{serial++}</td>
                  <td>Foundation for tanks</td>
                  <td>
                    Civil material required for tanks foundation. (Cement, Sand
                    & Stones)
                  </td>
                </tr>
              </>
            )}

          {quotationType !== "hydroponics only" && (
            <tr>
              <td>{serial++}</td>
              <td>
                Foundation for{" "}
                {quotationType?.includes("nethouse") ||
                quotationType?.includes("soilbasednethouse")
                  ? "nethouse"
                  : "polyhouses"}
              </td>
              <td>Civil material required for polyhouse polling foundation.</td>
            </tr>
          )}

          <tr>
            <td>{serial++}</td>
            <td>Miscellaneous work</td>
            <td>
              Civil material required for any miscellaneous work like support
              for pipes, motors, boards and pannels.
            </td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Cost of civil material</td>
            <td>The cost of civil material will be in the scope of client.</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CivilMaterials;
